var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("../../../assets/img/icon-phone.png")}}),_vm._v(" "),_c('div',{staticClass:"kc-phone-table"},[_c('div',{staticClass:"kc-phone-table-title"},[_vm._v("客服电话")]),_vm._v(" "),_c('div',{staticClass:"kc-phone-table-content"},[_vm._v(_vm._s(_vm.kefu.phone))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-468a0534","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookCourseDetail/child/Detailphone.vue
// module id = null
// module chunks = 